import { render, staticRenderFns } from "./PopupConstructorComponent.vue?vue&type=template&id=5d5e1cbb"
import script from "./PopupConstructorComponent.vue?vue&type=script&lang=js"
export * from "./PopupConstructorComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupConstructorComponent.vue?vue&type=style&index=0&id=5d5e1cbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports